import { c as e } from "../../../index-34b1f277.js";
import { FloatingBottomMultiselectActionsAnatomy as n } from "./FloatingBottomMultiselectActions.anatomy.es.js";
const { definePartsStyle: i, defineMultiStyleConfig: a } = e(
  n.keys
), t = i({
  floatingBar: {
    _dark: {
      backgroundColor: "neutral.900",
      borderColor: "primary.700"
    },
    minWidth: {
      md: "max-content"
    }
  },
  divider: {
    height: {
      base: "1px",
      md: "auto"
    },
    width: "1px",
    border: "none",
    backgroundColor: "primary.100",
    _dark: {
      backgroundColor: "primary.700"
    }
  },
  floatingBarContainerBase: {
    display: "flex",
    flexDir: "column",
    width: "100%"
  },
  floatingBarActionsContainerBase: {
    display: "flex",
    justifyContent: "space-between",
    paddingY: "spacing-100",
    paddingLeft: "spacing-300",
    paddingRight: "spacing-200"
  },
  floatingBarHeader: {
    display: "flex",
    gap: "spacing-100"
  },
  selectedItemsContainer: {
    display: "flex",
    gap: "spacing-25",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingY: {
      base: "0px",
      md: "spacing-150"
    },
    paddingX: {
      base: "0px",
      md: "spacing-200"
    }
  },
  selectedItems: {
    fontWeight: "medium",
    marginBottom: 0,
    color: "primary.700",
    lineHeight: "16px"
  },
  selectedItemsText: {
    color: "primary.700",
    lineHeight: "12px",
    display: { base: "none", md: "inline" }
  },
  actionsContainer: {
    display: "flex",
    gap: {
      base: "spacing-200",
      md: "spacing-100"
    },
    paddingY: {
      base: "spacing-250",
      md: "spacing-125"
    },
    paddingX: {
      base: "spacing-200",
      md: "0px"
    },
    paddingLeft: {
      md: "spacing-125"
    },
    paddingRight: {
      md: "spacing-200"
    },
    flexDir: {
      base: "column",
      md: "row"
    },
    _dark: {
      backgroundColor: "neutral.900"
    }
  },
  actionsContainerSelectAll: {
    display: {
      base: "none",
      md: "block"
    }
  },
  closeButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingX: { md: "spacing-100" }
  },
  closeIcon: {
    boxSize: "size-500"
  }
}), d = a({
  baseStyle: t
});
export {
  d as FloatingBottomMultiselectActions
};
//# sourceMappingURL=FloatingBottomMultiselectActions.es.js.map
